<div class="workSpace">
  <!--nombre y filtro-->
  <div class="w3-container w3-containertemplate" style="height: 7%;">
    <!--Titulo de modulo y subtitulo-->
    <div class="w3-caja-menu padreizquierda w3-quarter">
      <div class="w3-row hijoizquierda centradoVertical">
        <span class="w3-text-deep-orange w3-margin-right-filter w3-tituloPrincipal"> <b> {{ 'menu.'+dataService.moduleSelect | translate }} </b></span>
        <span class="w3-text-deep-orange">&bull;</span>
        <span class="w3-text-orange w3-margin-left-filter w3-subtituloPrincipal"> {{ 'menu.'+dataService.subModuleSelect | translate }} </span>
      </div>
    </div>
    <!--Filtros-->
    <div class="w3-caja-menu padreizquierda w3-rest" style="height: 100%">
      <div class="w3-half w3-row centradoVertical">
        
      </div>
    </div>
  </div>
  <!--CONTENIDO TABLERO  -->
  <div class="w3-center contenido">
    <div class="espacioForm">
      <div class="w3-row">
        <div class="w3-row w3-half">
          <div class="texto">
            <div class="w3-right zonaTexto2"><span class="w3-right textoInputs">{{'admin.ponderacion.selecCues' | translate}}</span></div>
          </div>
          <div class="w3-rest">
            <div class="zonaInput" [ngClass]="{'w3-disabled': edito}">
              <select class="contentSelect" id="cuestionario" value="default" (change)="seleccionCuestionario()">
                <option value="default">{{'admin.ponderacion.selec' | translate}}</option>
                @for (opt of cuestionarios; track opt.id) {
                  <option value="{{opt.id}}">{{opt.name}}</option>
                }
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="w3-row arbolTab">
        @if (cuesSelec !== 0) {
            <div class="w3-row elemento w3-scroll" [ngClass]="{'w3-disabled': edito}" (click)="editoD()">
            <div class="w3-row" style="width: 90%; margin-left: auto; margin-right: auto;">
                <mat-accordion class="example-headers-align">
                    @for (com of menu.elementos; track com.id; let n1 = $index) {
                        <mat-expansion-panel class="textoNoWrap" style="display: unset;"
                        [expanded]="idSel === (n1+1)" (opened)="ampliarNiv1(com, 'open')" (closed)="ampliarNiv1(com, 'close')">
                            <mat-expansion-panel-header class="alinLeft">
                                <mat-panel-title style="display: block;" >
                                    {{com.name}}
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <mat-accordion class="example-headers-align">
                                @if (com.elementos.length !== 0) {
                                    <div>
                                        @for (elem of com.elementos; track elem.id; let i = $index) {
                                            <mat-expansion-panel class="mat-expansion-panel textoNoWrap" style="display: unset;" 
                                                [expanded]="idSel2 === (i+1)" (opened)="ampliarNiv2(com, i, 'open')" (closed)="ampliarNiv2(com, i, 'close')">
                                                <mat-expansion-panel-header class="alinLeft">
                                                    <mat-panel-title style="display: block;">
                                                        {{elem.name}}
                                                    </mat-panel-title>
                                                </mat-expansion-panel-header>
                                                @for (q of elem.questions; track q.id) {
                                                    <div class="example-headers-align alinLeft" style="text-indent: 2em;">
                                                    {{q.order}} {{q.name}}
                                                    </div>
                                                }
                                            </mat-expansion-panel>
                                        }
                                    </div>
                                }@else if (com.elementos.length === 0) {
                                    <div>
                                        @for (p of com.questions; track p.id) {
                                            <div class="example-headers-align alinLeft" style="text-indent: 2em;">
                                                {{p.order}} {{p.name}}
                                            </div>
                                        }
                                    </div>
                                }
                            </mat-accordion>
                        </mat-expansion-panel>
                    }
                </mat-accordion>
            </div>
            </div>
        }

        @if (cuesSelec !== 0) {
            <div class="w3-row elemento w3-scroll">
                <div class="w3-row" style="width: 80%; margin-left: auto; margin-right: auto;">
                    <div class="w3-row" style="margin-bottom: 3vh;">
                        <div class="w3-left">
                            <button mat-flat-button color="success" class="w3-left" style="width: 60%;" (click)="validarCuestionario()"
                            [disabled]="publicar" [ngClass]="{'w3-disabled': publicar}">
                            {{'admin.ponderacion.validar' | translate}}
                            </button>
                        </div>
                        <div class="w3-right">
                            <button mat-flat-button color="success" class="w3-right" style="width: 50%;" (click)="ponderacionAuto()"
                            [disabled]="publicar" [ngClass]="{'w3-disabled': publicar}">
                            {{'admin.ponderacion.pondeAuto' | translate}}
                            </button>
                        </div>
                    </div>
                    <table class="w3-table">
                        <thead>
                            <tr class="w3-table-title">
                            <th class="w3-border-right-balance marginIzq" style="line-height: 1.2;">{{'admin.ponderacion.n°' | translate}}</th>
                            <th class="w3-border-right-balance marginIzq" style="line-height: 1.2;">{{'admin.ponderacion.descripcion'+encabezado | translate}}</th>
                            <th class="w3-border-right-balance marginIzq" style="line-height: 1.2;">{{'admin.ponderacion.peso' | translate}}</th>
                            </tr>
                        </thead>
                        @for (elem of ponderacion; track elem.id; let i= $index) {
                            <tbody>
                                <tr class="w3-table-trtd w3-center" >
                                    @if (encabezado == 1) {
                                        <td style="line-height: 1.2;" class="borderAllLow">{{i+1}}</td>
                                    }@else if (encabezado == 2) {
                                        <td style="line-height: 1.2;" class="borderAllLow">{{elem.order}}</td>
                                    }
                                    <td style="line-height: 1.2;" class="borderAllLow">{{elem.name}}</td>
                                    <td style="line-height: 1.2;" class="borderAllLow">
                                        <input id="{{'peso'+i}}" matInput type="number" class="inputPon w3-center" value="{{elem.weighting}}" 
                                        (change)="actualizarPeso()" min="0" max="100" matTooltip="Editar">
                                    </td>
                                </tr>
                            </tbody>
                        }
                        <tr class="w3-table-trtd">
                            <td class="borderAllLow alinLeft" style="line-height: 1.2; font-weight: bold;" colspan="2">{{'admin.ponderacion.total' | translate}}</td>
                            <td class="borderAllLow w3-center" style="line-height: 1.2; font-weight: bold;">{{total}}</td>
                        </tr>
                    </table>
                    <div class="w3-row w3-right" style="color: red; margin: 1vh 0;">
                        @if (total !=100) {
                            <span>{{'admin.ponderacion.errorSuma'|translate}}</span>
                        }
                    </div>
                    <div class="w3-row" style="margin-top: 1vh;">
                        <div class="w3-button w3-right">
                            <button mat-flat-button color="success" [disabled]="total != 100 || !edito" [ngClass]="{'w3-disabled': total != 100 || !edito}" 
                            (click)="guardarPonderacion()"
                            >{{'admin.ponderacion.guardar' | translate}}</button>
                        </div>
                        <div class="w3-button w3-right" style="margin-right: 1vw;">
                            <button mat-flat-button color="success" [disabled]="!publicar" [ngClass]="{'w3-disabled': !publicar}" 
                            (click)="changeStatus()"
                            >{{'admin.ponderacion.publicar' | translate}}</button>
                        </div>
                    </div>
                </div>
            </div>
        }

      </div>
    </div>
  </div>
  
</div>